import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { map, catchError, concatMap } from 'rxjs/operators';

import { SenderDomainActions } from '../actions';
import { EmailService } from '../services';

@Injectable()
export class SenderDomainEffects {
  fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SenderDomainActions.fetchRequest),
      concatMap(({ accountId }) =>
        this.service.fetchSenderDomains(accountId).pipe(
          map((senderDomains) =>
            SenderDomainActions.fetchSuccess({ senderDomains }),
          ),
          catchError(() => {
            this.toastr.error('Could not fetch technical sender domains');
            return [SenderDomainActions.fetchFailure()];
          }),
        ),
      ),
    ),
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SenderDomainActions.createRequest),
      concatMap(({ accountId, fromDomain, senderDomain }) =>
        this.service
          .createSenderDomain(accountId, fromDomain, senderDomain)
          .pipe(
            map((response) =>
              SenderDomainActions.createSuccess({ senderDomain: response }),
            ),
            catchError(() => {
              this.toastr.error('Could not create technical sender domain');
              return [SenderDomainActions.createFailure()];
            }),
          ),
      ),
    ),
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SenderDomainActions.deleteRequest),
      concatMap(({ domainId, accountId }) =>
        this.service.deleteSenderDomain(domainId, accountId).pipe(
          map(() => SenderDomainActions.deleteSuccess({ domainId })),
          catchError(() => {
            this.toastr.error('Could not delete technical sender domain');
            return [SenderDomainActions.deleteFailure()];
          }),
        ),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly service: EmailService,
    private readonly toastr: ToastrService,
  ) {}
}
